// libs
import { flowRight } from 'lodash'
import { connect } from 'react-redux'
import { RouteComponentProps } from 'react-router-dom'

// interfaces / constants
import { IRootState } from 'src/reducers/interface'
import {
  PostUpdateObjType,
  UPDATE_POST
} from 'src/utils/reporting/events_tracking/events_tracking'

// classes / components
import PostUpdate, {
  IMapRouteToProps,
  IOwnProps,
  IPostUpdateStoreState
} from 'src/components/post/update/update'
import withLoadingSpinner from 'src/high_order_components/with_loading_spinner'

// helpers
import { withRouterProps } from 'src/high_order_components/connect_route_props'
import { withContentItemMutations } from 'src/high_order_components/with_content_item_mutations'
import { withTrackerProps } from 'src/high_order_components/with_tracker_props'
import { IVerifiedUserProfile } from 'src/interfaces/user'

const mapStateToProps = (state: IRootState): IPostUpdateStoreState => {
  const selectedProfileId = state.user.selectedProfileId
  // The post update feature cannot have an intermediate profile, or not logged In one.
  const profile = state.user.profiles[
    selectedProfileId
  ] as IVerifiedUserProfile
  return {
    loggedInProfileAddress: profile.address,
    profileType: profile.type
  }
}

const mapRouteToProps = ({
  match,
  history,
  location
}: RouteComponentProps): IMapRouteToProps => ({
  history,
  matchUrl: match.url,
  path: location.pathname,
  search: location.search,
  startPath: location.state && location.state.startPath
})

export default flowRight(
  withRouterProps<IMapRouteToProps, IOwnProps>(mapRouteToProps),
  connect<IPostUpdateStoreState, unknown, IOwnProps & IMapRouteToProps>(
    mapStateToProps
  ),
  withTrackerProps<PostUpdateObjType, IOwnProps>(UPDATE_POST),
  withLoadingSpinner,
  withContentItemMutations
)(PostUpdate)
